import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Suspense } from "react";
import useFlag from "../../util/hooks/useFlag";
import { LikeRewardButton } from "../../reward-button";
import loadable from "../../loadable";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var LazyEditor = loadable(function () {
  return import(/*webpackChunkName: "rich-content" */"../../Editor");
});
var HtmlToReact = loadable(function () {
  return import(/* webpackChunkName: "rich-content" */"../../HTML");
});

/**
 * One comment
 * @param {{
 *  comment: object,
 *  user: {loggedIn: boolean, isAdmin: boolean, id: number}
 *  onCompose: (comment: object) => void,
 *  onEdit: (comment: object) => void,
 *  onDelete: (comment: object) => void,
 *  onLike: (comment: object) => void
 *  className: string
 * }}
 */
export var Comment = function Comment(_ref) {
  var comment = _ref.comment,
    user = _ref.user,
    onCompose = _ref.onCompose,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete,
    onLike = _ref.onLike,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var _ref2 = comment || {},
    User = _ref2.User,
    user_id = _ref2.user_id;
  var likes = comment && comment.AGG_LIKE || {
    user: 0,
    sum: 0
  };

  // Composing
  var _useFlag = useFlag(false),
    _useFlag2 = _slicedToArray(_useFlag, 3),
    composing = _useFlag2[0],
    showEditor = _useFlag2[1],
    hideEditor = _useFlag2[2];
  var handleCompose = function handleCompose() {
    return onCompose ? onCompose(showEditor) : showEditor();
  };

  // Save
  var handleSave = function handleSave(text) {
    if (text && text.replace(/<\/?[a-z\s="]+>/gi, "").trim().length) {
      onEdit(_objectSpread(_objectSpread({}, comment || {}), {}, {
        text: text
      }));
      hideEditor();
    }
  };

  // Delete
  var handleDelete = function handleDelete() {
    return confirm("Möchtest du diesen Kommentar wirklich löschen?") && onDelete(comment);
  };
  className += " comment " + (comment && "old" || "new");
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [!composing && /*#__PURE__*/_jsx("div", {
      className: "author",
      children: User && User.firstname || "Du"
    }), /*#__PURE__*/_jsx("div", {
      className: "body",
      children: composing && /*#__PURE__*/_jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/_jsx(LazyEditor, {
          uploadUrl: "/api_comments/upload",
          uploadAttrs: {
            accept: ".jpg,.jpeg,.png,.gif,.webp"
          },
          text: comment && comment.text || "",
          onSave: handleSave,
          onCancel: hideEditor,
          saveLabel: "Kommentar ".concat(comment ? "speichern" : "abschicken"),
          handlers: [["link", "image"]]
        })
      }) || /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "content",
          onClick: !comment ? handleCompose : undefined,
          children: /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(HtmlToReact, {
              preset: "basic",
              html: comment ? comment.text : "Sag was dazu ..."
            })
          })
        }), comment && /*#__PURE__*/_jsxs("div", {
          className: "footer",
          children: [/*#__PURE__*/_jsx("span", {
            className: "like",
            children: /*#__PURE__*/_jsxs(LikeRewardButton, {
              type: "confetti",
              isLiked: likes.user,
              shouldReward: false // TODO
              ,
              handleLikeToggle: function handleLikeToggle() {
                return onLike(comment);
              },
              children: ["Gef\xE4llt ", likes.sum > 0 ? likes.sum + " Mal" : "mir"]
            })
          }), user && user.loggedIn && (user.admin || parseInt(user.id) === user_id) && /*#__PURE__*/_jsxs("div", {
            className: "actions",
            children: [/*#__PURE__*/_jsxs("span", {
              className: "edit",
              onClick: showEditor,
              children: [/*#__PURE__*/_jsx("i", {
                className: "fa fa-pencil"
              }), "Bearbeiten"]
            }), /*#__PURE__*/_jsxs("span", {
              className: "delete",
              onClick: handleDelete,
              children: [/*#__PURE__*/_jsx("i", {
                className: "fa fa-trash"
              }), "L\xF6schen"]
            })]
          })]
        })]
      })
    })]
  });
};
export default Comment;
//# sourceMappingURL=Comment.js.map